export default "__VITE_ASSET__DV$RM7fN__"